import { h } from 'preact'
import TopicModeration from '../../topic-moderation'
import { Topic } from '../../topic-moderation/interfaces'

const IdeasModeration = ({ topic, topicType } : { topic: Topic, topicType: 'idea' }) =>
  <TopicModeration topic={topic} topicType={topicType} />

export default IdeasModeration
